<template>
<div class="kpi-value">
  <div class="kpi-value__value">
    {{value}}
  </div>
  <div
    v-if="label !== ''"
    class="kpi-value__label"
    >
    {{label}}
  </div>
</div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: '-'
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="less" scoped>
  .kpi-value {
    position: relative;
    margin-right: 50px;

    &__value {
      font-size: 36px;
      font-weight: 700;
    }

    &__label {
      font-size: 14px;
    }
  }
</style>
